export default __webpack_public_path__ + "static/media/Armguards of the Tormentor.15e25092.jpg";